module.exports = {
    userInterfaceMainScenario: 0,
    userInterfaceMainEvent: 1,
    userInterfaceMainMailing: 2,
    userInterfaceMainClient: 3,
    userInterfaceMainModule: 4,
    userInterfaceMainVariable: 5,
    userInterfaceMainOrder: 6,
    userInterfaceMainCatalog: 7,
    userInterfaceMainDelivery: 8,
    userInterfaceMainPromo: 9,
    userInterfaceMainCard: 10,
    userInterfaceMainPost: 11,
    userInterfaceMainJump: 12,
    userInterfaceMainStat: 13,
    userInterfaceMainTool: 14,
    menuItems: [
        {
            title: 'Сценарий',
            icon: 'message',
            url: '/bot{{botId}}/message',
            interfaceIndex: 0
        },
        {
            title: 'События',
            icon: 'add_alert',
            url: '/bot{{botId}}/event',
            interfaceIndex: 1
        },
        {
            title: 'Рассылки',
            icon: 'question_answer',
            url: '/bot{{botId}}/mailing',
            interfaceIndex: 2
        },
        {
            title: 'Клиенты',
            icon: 'group',
            url: '/bot{{botId}}/client',
            interfaceIndex: 3
        },
        {
            title: 'Модули',
            icon: 'category',
            url: '/bot{{botId}}/module',
            interfaceIndex: 4
        },
        {
            title: 'Переменные',
            icon: 'settings_ethernet',
            url: '/bot{{botId}}/variable',
            interfaceIndex: 5
        },
        {
            title: 'Заказы',
            icon: 'group',
            url: '/bot{{botId}}/order',
            interfaceIndex: 6
        },
        {
            title: 'Каталог товаров',
            icon: 'group',
            url: '/bot{{botId}}/catalog',
            interfaceIndex: 7
        },
        {
            title: 'Доставка',
            icon: 'group',
            url: '/bot{{botId}}/delivery',
            interfaceIndex: 8
        },
        {
            title: 'Промокоды',
            icon: 'group',
            url: '/bot{{botId}}/promo',
            interfaceIndex: 9
        },
        {
            title: 'Карточка',
            icon: 'group',
            url: 'card',
            interfaceIndex: 10
        },
        {
            title: 'Посты',
            icon: 'post_add',
            url: '/bot{{botId}}/post',
            interfaceIndex: 11
        },
        {
            title: 'Переходы',
            icon: 'link',
            url: '/bot{{botId}}/jump',
            interfaceIndex: 12
        },
        {
            title: 'Статистика',
            icon: 'poll',
            url: '/bot{{botId}}/stats',
            interfaceIndex: 13
        },
        {
            title: 'Инструменты',
            icon: 'build',
            url: '/bot{{botId}}/tool',
            interfaceIndex: 14
        }
    ]
}
